import React from 'react'

interface PaymentTimelineRowInfoProps {
  generalInfo: string
  boldInfo?: string
  testid?: string
}

export const PaymentTimelineRowInfo = ({
  generalInfo,
  boldInfo,
  testid,
}: PaymentTimelineRowInfoProps) => {
  return (
    <div>
      <span className="text-body-regular text-foreground-prominent">{generalInfo}</span>
      {boldInfo && (
        <span className="pl-1">
          <strong className="text-label text-foreground-prominent" data-testid={testid}>
            {boldInfo}
          </strong>
        </span>
      )}
    </div>
  )
}
